<template>
  <div class="flex h-full w-full flex-col">
    <div class="space-y-2 pb-2">
      <h4 class="text-2xs font-bold uppercase text-body-color">
        Equipment List
      </h4>
      <router-link
        :to="{
          name: 'Carrier Brokers Show Page',
          params: { id: $store.state.show?.showBroker?.id },
        }"
        target="_blank"
        class="text-xl text-yellow-600 underline"
      >
        {{
          capitalizeWords(
            $store.state.show?.showBroker?.legal_name.toLowerCase()
          )
        }}
      </router-link>
    </div>
    <div class="flex flex-col space-y-3 rounded-md">
      <div class="grid grid-cols-3 gap-3">
        <div
          class="flex flex-col items-center gap-2 rounded-md border-2 p-4 py-6 text-center"
          :class="{
            'border-yellow-500 bg-yellow-20': !isWatchdogActiveOnDomain,
            'watchdog-bg-pearl border-gray-over-dark': isWatchdogActiveOnDomain,
          }"
        >
          <div class="text-4xl text-body-color">
            {{ quantityByWeightClass.power_units.count }}
          </div>
          <div class="flex flex-col items-center justify-center">
            <svg
              class="h-16 w-16"
              viewBox="0 0 35 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8442 10.5792L11.4987 10.7896V10.7896L10.8442 10.5792ZM15.7915 9.625H16.479V8.9375H15.7915V9.625ZM15.7915 19.25V19.9375H16.479V19.25H15.7915ZM3.4165 19.25H2.729V19.9375H3.4165V19.25ZM4.96338 16.5V17.1875H5.36546L5.56259 16.8371L4.96338 16.5ZM6.116 14.4509L5.51679 14.1138L6.116 14.4509ZM9.82499 13.75V14.4375H10.3261L10.4795 13.9604L9.82499 13.75ZM12.1532 8.9375C11.2573 8.9375 10.4638 9.5159 10.1896 10.3689L11.4987 10.7896C11.5901 10.5053 11.8546 10.3125 12.1532 10.3125V8.9375ZM15.7915 8.9375H12.1532V10.3125H15.7915V8.9375ZM16.479 16.5V9.625H15.104V16.5H16.479ZM15.104 16.5V19.25H16.479V16.5H15.104ZM15.7915 18.5625H3.4165V19.9375H15.7915V18.5625ZM4.104 19.25V17.875H2.729V19.25H4.104ZM4.104 17.875C4.104 17.4953 4.41181 17.1875 4.7915 17.1875V15.8125C3.65242 15.8125 2.729 16.7359 2.729 17.875H4.104ZM4.7915 17.1875H4.96338V15.8125H4.7915V17.1875ZM5.51679 14.1138L4.36417 16.1629L5.56259 16.8371L6.71521 14.7879L5.51679 14.1138ZM7.31442 13.0625C6.56929 13.0625 5.8821 13.4644 5.51679 14.1138L6.71521 14.7879C6.83698 14.5715 7.06604 14.4375 7.31442 14.4375V13.0625ZM9.82499 13.0625H7.31442V14.4375H9.82499V13.0625ZM10.1896 10.3689L9.17047 13.5396L10.4795 13.9604L11.4987 10.7896L10.1896 10.3689Z"
                fill="#6D7181"
              />
              <path
                d="M15.7915 19.25H15.104V19.9375H15.7915V19.25ZM18.5415 19.25V19.9375H19.229V19.25H18.5415ZM18.5415 8L17.9391 7.66868L17.854 7.82341V8H18.5415ZM19.5297 6.20334L20.1321 6.53466L19.5297 6.20334ZM16.479 8C16.479 6.99898 17.2905 6.1875 18.2915 6.1875V4.8125C16.5311 4.8125 15.104 6.23959 15.104 8H16.479ZM16.479 19.25V8H15.104V19.25H16.479ZM18.5415 18.5625H15.7915V19.9375H18.5415V18.5625ZM17.854 8V19.25H19.229V8H17.854ZM18.9273 5.87202L17.9391 7.66868L19.1439 8.33132L20.1321 6.53466L18.9273 5.87202ZM19.1138 6.1875C18.9519 6.1875 18.8492 6.0139 18.9273 5.87202L20.1321 6.53466C20.558 5.76016 19.9977 4.8125 19.1138 4.8125V6.1875ZM18.2915 6.1875H19.1138V4.8125H18.2915V6.1875Z"
                fill="#6D7181"
              />
              <circle
                cx="27.2915"
                cy="22"
                r="2.75"
                stroke="#6D7181"
                stroke-width="1.375"
              />
              <circle
                cx="27.2915"
                cy="22"
                r="1.375"
                fill="#6D7181"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.729 18.5625H3.4165H30.7718H31.1773L31.3735 18.9175L32.1334 20.2925L32.8932 21.6675L33.4569 22.6875H32.2915H29.4549C29.5114 22.4678 29.5415 22.2374 29.5415 22C29.5415 21.7626 29.5114 21.5322 29.4549 21.3125H31.1261L30.9299 20.9575L30.3662 19.9375H28.6105C28.1257 19.5096 27.4889 19.25 26.7915 19.25C26.0941 19.25 25.4573 19.5096 24.9725 19.9375H23.1105C22.6257 19.5096 21.9889 19.25 21.2915 19.25C20.5941 19.25 19.9573 19.5096 19.4725 19.9375H9.36051C8.87573 19.5096 8.23894 19.25 7.5415 19.25C6.84407 19.25 6.20728 19.5096 5.7225 19.9375H4.104V21.3125H4.87814C4.82158 21.5322 4.7915 21.7626 4.7915 22C4.7915 22.2374 4.82158 22.4678 4.87814 22.6875H3.4165H2.729V22V19.25V18.5625ZM10.2915 22C10.2915 21.7626 10.2614 21.5322 10.2049 21.3125H18.6281C18.5716 21.5322 18.5415 21.7626 18.5415 22C18.5415 22.2374 18.5716 22.4678 18.6281 22.6875H10.2049C10.2614 22.4678 10.2915 22.2374 10.2915 22ZM24.0415 22C24.0415 21.7626 24.0114 21.5322 23.9549 21.3125H24.1281C24.0716 21.5322 24.0415 21.7626 24.0415 22ZM24.0415 22C24.0415 22.2374 24.0716 22.4678 24.1281 22.6875H23.9549C24.0114 22.4678 24.0415 22.2374 24.0415 22Z"
                fill="#6D7181"
              />
              <circle
                cx="21.2915"
                cy="22"
                r="2.75"
                stroke="#6D7181"
                stroke-width="1.375"
              />
              <circle
                cx="21.2915"
                cy="22"
                r="1.375"
                fill="#6D7181"
              />
              <circle
                cx="7.2915"
                cy="22"
                r="2.75"
                stroke="#6D7181"
                stroke-width="1.375"
              />
              <circle
                cx="7.2915"
                cy="22"
                r="1.375"
                fill="#6D7181"
              />
              <path
                d="M11.6665 19.25H15.7915V23.375C15.7915 24.1344 15.1759 24.75 14.4165 24.75H13.0415C12.2821 24.75 11.6665 24.1344 11.6665 23.375V19.25Z"
                stroke="#6D7181"
                stroke-width="1.375"
              />
              <path
                d="M11.6665 22H15.7915"
                stroke="#6D7181"
                stroke-width="1.375"
              />
              <path
                d="M12.5051 13.0625L12.7801 11.6875H13.729V13.0625H12.5051Z"
                fill="#C4C4C4"
                stroke="#6D7181"
                stroke-width="1.375"
              />
              <path
                d="M4.7915 16.5H7.37921C8.39018 16.5 9.38726 16.7354 10.2915 17.1875V17.1875"
                stroke="#6D7181"
                stroke-width="1.375"
              />
            </svg>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.power_units.label }}
            </h4>
          </div>
        </div>
        <div
          class="flex flex-col items-center gap-2 rounded-md border-2 p-4 py-6 text-center"
          :class="{
            'border-yellow-500 bg-yellow-20': !isWatchdogActiveOnDomain,
            'watchdog-bg-pearl border-gray-over-dark': isWatchdogActiveOnDomain,
          }"
        >
          <div class="text-4xl text-body-color">
            {{ quantityByWeightClass.trailers.count }}
          </div>
          <div class="flex flex-col items-center justify-center">
            <svg
              class="h-16 w-16"
              viewBox="0 0 34 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="19.3332"
                cy="22.6667"
                r="2.66667"
                stroke="#6D7181"
                stroke-width="1.33333"
              />
              <circle
                cx="19.3333"
                cy="22.6673"
                r="1.33333"
                fill="#6D7181"
              />
              <circle
                cx="25.3332"
                cy="22.6667"
                r="2.66667"
                stroke="#6D7181"
                stroke-width="1.33333"
              />
              <circle
                cx="25.3333"
                cy="22.6673"
                r="1.33333"
                fill="#6D7181"
              />
              <path
                d="M5.3335 21.334V24.0007H1.3335"
                stroke="#6D7181"
                stroke-width="1.33333"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 7.33398H2.66667H30.6667H31.3333V8.00065V21.334V22.0007H30.6667H27.916C27.7812 21.4765 27.491 21.0147 27.0974 20.6673H30V8.66732H3.33333V20.6673H18.2361C17.8425 21.0147 17.5522 21.4765 17.4173 22.0007H2.66667H2V21.334V8.00065V7.33398ZM23.5693 20.6673C23.1757 21.0147 22.8855 21.4765 22.7507 22.0007H22.5826C22.4477 21.4765 22.1574 21.0147 21.7638 20.6673H23.5693Z"
                fill="#6D7181"
              />
              <path
                d="M9.3335 21.334V23.334H17.3335"
                stroke="#6D7181"
                stroke-width="1.33333"
              />
            </svg>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.trailers.label }}
            </h4>
          </div>
        </div>
        <div
          class="flex flex-col items-center gap-2 rounded-md border-2 p-4 py-6 text-center"
          :class="{
            'border-yellow-500 bg-yellow-20': !isWatchdogActiveOnDomain,
            'watchdog-bg-pearl border-gray-over-dark': isWatchdogActiveOnDomain,
          }"
        >
          <div class="text-4xl uppercase text-body-color">
            {{ quantityByWeightClass.largest_weight_class.label }}
          </div>
          <div class="flex flex-col items-center justify-center">
            <div class="flex h-16 items-center justify-center gap-1">
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_1.level,
                }"
              ></div>
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_2.level,
                }"
              ></div>
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_3.level,
                }"
              ></div>
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_4.level,
                }"
              ></div>
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_5.level,
                }"
              ></div>
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_6.level,
                }"
              ></div>
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_7.level,
                }"
              ></div>
              <div
                class="h-8 w-2 rounded-md border-2 border-body-color"
                :class="{
                  'bg-body-color':
                    quantityByWeightClass[
                      quantityByWeightClass.largest_weight_class.type
                    ]?.level >= quantityByWeightClass.class_8.level,
                }"
              ></div>
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              Largest Vehicle Class
            </h4>
          </div>
        </div>
      </div>
      <div
        class="relative flex w-full flex-col space-y-2 rounded-md border-2 p-6"
        :class="{
          'border-yellow-500 bg-yellow-20': !isWatchdogActiveOnDomain,
          '': isWatchdogActiveOnDomain,
        }"
      >
        <h4 class="text-2xs font-bold uppercase text-body-color">
          Equipment by Vehicle Class
        </h4>
        <div class="grid w-full grid-cols-4 grid-rows-2 gap-3">
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-4"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_1.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_1.label }}
            </h4>
          </div>
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-6"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_2.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_2.label }}
            </h4>
          </div>
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-6"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_3.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_3.label }}
            </h4>
          </div>
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-6"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_4.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_4.label }}
            </h4>
          </div>
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-6"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_5.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_5.label }}
            </h4>
          </div>
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-6"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_6.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_6.label }}
            </h4>
          </div>
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-6"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_7.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_7.label }}
            </h4>
          </div>
          <div
            class="flex flex-col items-center justify-center gap-2 rounded-md border-2 p-6"
            :class="{
              'border-yellow-500 bg-yellow-10': !isWatchdogActiveOnDomain,
              'watchdog-bg-pearl border-gray-over-dark':
                isWatchdogActiveOnDomain,
            }"
          >
            <div class="text-3xl text-body-color">
              {{ quantityByWeightClass.class_8.count }}
            </div>
            <h4 class="text-2xs font-bold uppercase text-body-color">
              {{ quantityByWeightClass.class_8.label }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoClassEightTrucksInsight',

  props: {
    insight: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      quantityByWeightClass: {
        power_units: {
          count: 0,
          label: 'Power Units',
        },
        trailers: {
          count: 0,
          label: 'Trailers',
        },
        class_1: {
          count: 0,
          label: 'Class 1',
          level: 1,
        },
        class_2: {
          count: 0,
          label: 'Class 2',
          level: 2,
        },
        class_3: {
          count: 0,
          label: 'Class 3',
          level: 3,
        },
        class_4: {
          count: 0,
          label: 'Class 4',
          level: 4,
        },
        class_5: {
          count: 0,
          label: 'Class 5',
          level: 5,
        },
        class_6: {
          count: 0,
          label: 'Class 6',
          level: 5,
        },
        class_7: {
          count: 0,
          label: 'Class 7',
          level: 7,
        },
        class_8: {
          count: 0,
          label: 'Class 8',
          level: 8,
        },
        largest_weight_class: {
          type: '',
          label: '',
        },
      },
    };
  },
  computed: {
    authorityColor() {
      var authority =
        this.$store.state.carriers?.showCarrierInspections
          ?.length_of_authority_in_months;
      if (authority > 15) {
        return 'text-green-500';
      } else if (authority > 6) {
        return 'text-orange-500';
      } else {
        return 'text-red-500';
      }
    },
    vehicles() {
      return this.$store.state.carriers?.showCarrierEquipment?.rows || [];
    },
  },
  mounted() {
    this.calculateWeightClasses(this.vehicles);
  },
  methods: {
    capitalizeWords: function (str) {
      return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
        .replace('Llc', 'LLC');
    },
    classType: function (vehicle) {
      switch (true) {
        case vehicle.weight_class == null:
          return null;
        case vehicle.weight_class.includes('Class 1'):
          return 'Class 1';
        case vehicle.weight_class.includes('Class 2'):
          return 'Class 2';
        case vehicle.weight_class.includes('Class 3'):
          return 'Class 3';
        case vehicle.weight_class.includes('Class 4'):
          return 'Class 4';
        case vehicle.weight_class.includes('Class 5'):
          return 'Class 5';
        case vehicle.weight_class.includes('Class 6'):
          return 'Class 6';
        case vehicle.weight_class.includes('Class 7'):
          return 'Class 7';
        case vehicle.weight_class.includes('Class 8'):
          return 'Class 8';
        default:
          return null;
      }
    },
    determineLargestWeightClass: function () {
      var largestClass = '';
      if (this.quantityByWeightClass.class_7.count > 0) {
        largestClass = 'class_7';
      } else if (this.quantityByWeightClass.class_6.count > 0) {
        largestClass = 'class_6';
      } else if (this.quantityByWeightClass.class_5.count > 0) {
        largestClass = 'class_5';
      } else if (this.quantityByWeightClass.class_4.count > 0) {
        largestClass = 'class_4';
      } else if (this.quantityByWeightClass.class_3.count > 0) {
        largestClass = 'class_3';
      } else if (this.quantityByWeightClass.class_2.count > 0) {
        largestClass = 'class_2';
      } else {
        largestClass = 'class_1';
      }
      this.quantityByWeightClass.largest_weight_class.type = largestClass;
      this.quantityByWeightClass.largest_weight_class.label =
        this.quantityByWeightClass[largestClass].label;
    },
    calculateWeightClasses: function (vehicles) {
      var self = this;
      vehicles.forEach(function (vehicle) {
        if (vehicle.is_type == 'power_unit') {
          self.quantityByWeightClass.power_units.count += 1;
        } else if (vehicle.is_type == 'trailer') {
          self.quantityByWeightClass.trailers.count += 1;
        }
        var weightClass = self.classType(vehicle);
        if (weightClass) {
          weightClass = weightClass?.toLowerCase()?.replaceAll(' ', '_');
          self.quantityByWeightClass[weightClass].count += 1;
        }
      });
      this.determineLargestWeightClass();
    },
  },
  // watch: {
  //   vehicles: function(newVal, oldVal) {
  //     if (newVal.length > 0 && oldVal.length == 0) {
  //       newVal.array.forEach(function(vehicle) {
  //         if (vehicle.is_type == 'power_unit') {
  //           this.quantityByWeightClass.power_units.count += 1;
  //         } else if (vehicle.is_type == 'trailer') {
  //           this.quantityByWeightClass.trailers.count += 1;
  //         }
  //         var weightClass = this.classType(vehicle);
  //         if (weightClass) {
  //           weightClass = weightClass?.toLowerCase?.replaceAll(" ", "_");
  //           this.quantityByWeightClass[weightClass].count += 1;
  //         }
  //       });

  //     }
  //     console.log('quantityByWeightClass = '+JSON.stringify(this.quantityByWeightClass));
  //   }
  // }
};
</script>
